module.exports = __webpack_public_path__ + "static/media/Jeton.ee8ba2b6.svg";